<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="item in currentPath"
                        :key="item.name"
                        :to="{ path: item.path }">{{itemTitle(item)}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  name: 'breadcrumbNav',
  props: {
    currentPath: Array
  },
  methods: {
    itemTitle (item) {
      return item.title;
    }
  }
};
</script>

